<template>
	
	<div class="container page">
		
		<div class="header">
			
			<div class="nav-bar van-nav-bar van-hairline--bottom">
				<div class="van-nav-bar__content">
					<div class="van-nav-bar__left" @click="back()">
						<i class="van-icon van-icon-arrow-left" style="color: rgb(255, 255, 255);"></i>
					</div>
					<div class="van-nav-bar__title van-ellipsis">{{$t('my.grcs')}}</div>
				</div>
			</div>
			
			<div class="info">
				<p class="title">{{$t("withdraw.t1")}}({{$t("withdraw.t2")}})</p>
				<p class="value">{{ userInfo.money }}</p>
				<p class="tip">{{$t("withdraw.t3")}}:{{$t("withdraw.t4")}} - {{$t("withdraw.t5")}}</p>
			</div>
			
			<div class="content">
				<div class="datalist">
					<div class="datalistitem">
						<div class="datalistitemValue">{{ this.userInfo.money }}</div>
						<div class="datalistitemKey">{{$t("withdraw.t6")}}</div>
						<div class="datalistitemRightLine"></div>
					</div>
					<div class="datalistitem">
						<div class="datalistitemValue">{{ this.userInfo.recharge}}</div>
						<div class="datalistitemKey">{{$t("withdraw.t7")}}</div>
						<div class="datalistitemRightLine"></div>
					</div>
					<div class="datalistitem">
						<div class="datalistitemValue">{{ this.userInfo.withdraw }}</div>
						<div class="datalistitemKey">{{$t("withdraw.t8")}}</div>
						<div class="datalistitemRightLine"></div>
					</div>
					<div class="datalistitem">
						<div class="datalistitemValue">{{ this.userInfo.game }}</div>
						<div class="datalistitemKey">{{$t("withdraw.t9")}}</div>
						<div class="datalistitemRightLine"></div>
					</div>
				</div>
			</div>
					
			
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				win_money: 0,
				userInfo:{}
			};
		},
		methods: {
			back() {
				return window.history.back();
			},
			getUserInfo() {
				this.$http({
					method: "get",
					url: "user_info",
				}).then((res) => {
					if (res.code === 200) {
						this.userInfo = res.data;
					} else if (res.code === 401) {
						this.$toast(res.msg);
					}
				});
			},
		},
		created() {
			if (!localStorage.getItem('token')) {
				this.$router.push({
					path: '/Login'
				})
			} else {
				this.getUserInfo();
			}
		}
	};
</script>

<style lang='less' scoped>
	@import "../assets/css/base.css";

	.nav-bar {
		background: none;
	}

	.container .header {
		background: linear-gradient(30deg, #7d76ef, #d63f8c);
	}

	.container .header .info {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		padding-bottom: 20px;
		padding-top: 10px;
		margin: auto;
	}

	.container .header .info .title {
		font-size: 25px;
		color: #e5e5e5;
	}

	.container .header .info .value {
		margin: 10px auto;
		color: #fff;
		font-size: 50px;
		border-bottom: 1px solid #fff;
	}

	.container .header .info .tip {
		font-size: 30px;
		color: #e5e5e5;
	}

	.container .content {
		flex: 1;
		background: #f2f2f5;
	}

	.container .content .datalist {
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		align-items: center;
		justify-content: flex-start;
	}

	.container .content .datalist .datalistitem {
		position: relative;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		height: 26.667vw;
		width: 50%;
	}

	.container .content .datalist .datalistitem .datalistitemValue {
		color: #ff253f;
		font-size: 35px;
		margin-bottom: 10px;
		margin-top: 10px;
	}

	.container .content .datalist .datalistitem .datalistitemKey {
		color: #979799;
		font-size: 25px;
		margin-bottom: 10px;
		margin-top: 10px;
	}
</style>